module.exports = __webpack_public_path__ + "img/rock-big-17.e1d4dc73.png";